/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListReportDealsQueryResponse,
  ListReportDealsQueryParams,
} from '../types/ListReportDeals'

function getListReportDealsUrl() {
  const res = { method: 'GET', url: `/api/v1/reports/deals/` as const }
  return res
}

/**
 * @description Paginated, filterable list of deal reports. Query params mirror DealReportFilter (reports/filters/deal_report_filters.py) plus search/sort/pagination; several params ending in `_less`/`_greater` or prefixed `cc_` have V1-compatible aliases noted below.
 * @summary List deal reports
 * {@link /api/v1/reports/deals/}
 */
export async function listReportDeals(
  params?: ListReportDealsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListReportDealsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListReportDealsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
